import ListService from "@/services/ListService";

const state = () => ({
  list: {},
});

const getters = {
  getList: (state) => {
    return state.list;
  },
};

const actions = {
  load({ commit, state }, listId) {
    if (state.list.id == listId) {
      return state.list;
    }
    return ListService.get(listId).then(
      (res) => {
        const list = res.data;
        commit("setList", list);
        return Promise.resolve(list);
      },
      (err) => {
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        return Promise.reject(message);
      }
    );
  },
};

const mutations = {
  setList(state, list) {
    state.list = list;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
